import './simple-reservation-form.scss';
import $ from 'jquery';
import differenceInDays from 'date-fns/differenceInDays';

const allowedStartAts = [1, 8, 16, 24];

$(document).ready(function() {
  const selectors = {
    wrapper: '.shortcode-simple-reservation-form',
    startAt: '.shortcode-simple-reservation-form .sp-start-at',
  };
  if ($(selectors.wrapper).length) {
    $(selectors.startAt).on('keyup keydown', function(e) {
      e.preventDefault();
    });

    $(selectors.startAt).datepicker({
      dateFormat: 'dd/mm/yy',
      beforeShowDay: function(date) {
        if (differenceInDays(date, new Date()) < 0)
          return [false, 'sp-reservation-date-in-the-past'];
        if (allowedStartAts.indexOf(date.getDate()) === -1) {
          return [false, 'sp-reservation-date-disabled'];
        } else {
          if (!IsAvailable(date)) {
            return [false, 'sp-reservation-date-disabled'];
          }
        }
        return [true];
      },
    });
  }
});

function IsAvailable(date) {
  const { apartments } = salaktaPlageConfig;
  // get first and last reservation

  let occurrenceCount = 0;
  apartments.map(apartment => {
    let futureReservations = getFutureReservations(apartment);
    futureReservations.map(reservation => {
      if (reservation.start_at <= date && date < reservation.end_at) {
        occurrenceCount++;
      }
    });
  });
  if (occurrenceCount === apartments.length) {
    return false;
  }
  return true;
}

function getFutureReservations({ future_reservations }) {
  return future_reservations
    .map(function(item) {
      const { start_at, end_at } = item;
      const new_start_at = new Date(
        +start_at.slice(0, 4),
        +start_at.slice(4, 6) - 1,
        +start_at.slice(6)
      );
      const new_end_at = new Date(
        +end_at.slice(0, 4),
        +end_at.slice(4, 6) - 1,
        +end_at.slice(6)
      );

      return {
        ...item,
        start_at: new_start_at,
        end_at: new_end_at,
      };
    })
    .sort(function compare(a, b) {
      return a.start_at - b.start_at;
    });
}
